import { DeleteOutlined } from '@ant-design/icons';
import { Button, Space, Typography } from 'antd';

import DeleteConfirmPopup from 'components/DeleteConfirmPopup';

import React from 'react';

const RemoveButton = ({
  record,
  actionRemove,
  titleKey = 'name',
  disabled = false,
  keyB='id'
}) => {
  return disabled ? (
    <Button
      type="default"
      size="small"
      icon={<DeleteOutlined />}
      disabled={disabled}
    />
  ) : (
    <Space>
      <DeleteConfirmPopup
        onDelete={() =>
          actionRemove({
            variables: {
              [keyB]: record[keyB]
            }
          })
        }
        title={
          <Typography.Text>
            Bạn muốn xoá{' '}
            <Typography.Text strong>{record?.[titleKey]}</Typography.Text> ?
          </Typography.Text>
        }
      >
        <Button type="default" size="small" icon={<DeleteOutlined />} />
      </DeleteConfirmPopup>
    </Space>
  );
};

export default RemoveButton;
